import type { Nullable } from '../../lib/typeHelpers.no-deps'
import type { ChatPromptId } from '../aiChats/types.no-deps'
import type { FlowBuilderPromptId } from '../aiFlowBuilderPrompts/types'

// List of credit balances currently used.
export enum CreditBalanceSlug {
    AI = 'ai',
}

export type DBCreditBalance = {
    id: number
    slug: string
    paidCreditsBalance: number
    freeCreditsLimit: number
    lastModified: Date
}

export type CreditBalance = {
    id: number
    slug: string
    paidCreditsBalance: number
    freeCreditsBalance: number
    freeCreditsLimit: number
    totalBalance: number
}

export type DBCreditTransaction = {
    id: number
    creditBalanceId: number
    totalCredits: number
    freeCreditsSpent: number
    monetarySum: Nullable<number>
    userId: Nullable<number>
    note: Nullable<string>
    aiChatPromptId: Nullable<ChatPromptId>
    aiFlowBuilderPromptId: Nullable<FlowBuilderPromptId>
    createdAt: Date
}

// Expanded version of `DBCreditTransaction`
export type CreditTransaction = {
    id: number
    creditBalanceSlug: string
    totalCredits: number
    freeCreditsSpent: number
    monetarySum: Nullable<number>
    author: Nullable<{
        id: number
        email: string
    }>
    note: Nullable<string>
    createdAt: Date
}

export type ConsumeCreditsResult = {
    transactionId: Nullable<number>
    creditBalanceSlug: string

    // Post-transaction balance
    freeCreditsBalance: number
    freeCreditsSpent: number
    paidCreditsBalance: number
    paidCreditsSpent: number
    totalBalance: number
}

export type GrantCreditsResult = {
    transactionId: number
    creditBalanceSlug: string
    creditsGranted: number

    // Post-transaction balance
    freeCreditsBalance: number
    paidCreditsBalance: number
    totalBalance: number
}

export const CREDITS_COST = {
    aika: 1, // AI Knowledge Assistant
    aifb: 5, // AI Flow Builder
}
